import {langCodes, langCode} from './localePrefix'

// Maps each legacy SPA slug to the WordPress URL that replaced it, keyed by URL
// locale prefix. wpBase is root-relative so every environment stays on its own host.
const wpBase = '/'
export const movedPages = {
  et: {
    'kuidas-investeerida': wpBase + 'et/kuidas-see-tootab/',
    abi: wpBase + 'et/abi/',
    laenuandjad: wpBase + 'loan-originators/'
  },
  de: {
    'how-it-works': wpBase + 'de/wie-funktioniert-das/',
    help: wpBase + 'de/help/',
    'loan-originators': wpBase + 'loan-originators/'
  },
  es: {
    'como-funciona': wpBase + 'es/como-funciona/',
    ayuda: wpBase + 'es/ayuda/',
    'originadores-de-prestamos': wpBase + 'loan-originators/'
  }
}
// Two sets of paths deliberately get no SPA route, and both rely on the same server
// rule: the web server serves them from WordPress and must never hand them to the SPA,
// which would answer with the /404 catch-all.
//   1. The English slugs below - WordPress serves these at the unprefixed path.
//   2. The locale paths that already ARE their own WordPress target (/et/abi, /de/help,
//      /es/como-funciona, /es/ayuda) - the self-target guard below skips them, because a
//      stub pointing at itself would redirect-loop.
// No in-app navigation reaches either set: every WordPress link is a plain href, so the
// SPA router is never asked for these paths.
const englishSlugs = ['how-it-works', 'help', 'loan-originators']

// Route stubs redirecting legacy SPA paths to their WordPress URLs,
// preserving any query string and fragment.
export default function buildMovedRoutes(pages = movedPages)
{
  const knownPrefixes = Object.keys(langCodes).map(locale => langCode(locale)).filter(code => code !== 'en')
  const movedRoutes = []
  const registeredPaths = {}
  Object.keys(pages).forEach(locale =>
  {
    // A typo here (e.g. 'ee' for 'et') would register routes nobody visits. This runs at
    // router import, so it must not throw - that would blank the whole site over one locale's
    // redirect stubs. The spec asserts every real key is known, so a typo fails in CI.
    if (knownPrefixes.indexOf(locale) === -1)
    {
      console.error('movedPages key "' + locale + '" is not a known URL locale prefix; its redirects are skipped')
      return
    }
    Object.keys(pages[locale]).forEach(slug =>
    {
      const url = pages[locale][slug]
      const targetPath = url.replace(/\/+$/, '')
      const redirectToWordpress = (to, from, next) =>
      {
        window.location.replace(url + to.fullPath.slice(to.path.length))
        // The browser is unloading; abort the router navigation explicitly so a
        // blocked replace() cannot leave it pending.
        next(false)
      }
      const oldPaths = ['/' + locale + '/' + slug]
      if (englishSlugs.indexOf(slug) === -1)
      {
        oldPaths.push('/' + slug)
      }
      oldPaths.forEach(path =>
      {
        // Self-targeting stubs would redirect-loop; see set 2 above.
        if (path !== targetPath && !registeredPaths[path])
        {
          registeredPaths[path] = true
          movedRoutes.push({path: path, beforeEnter: redirectToWordpress})
        }
      })
    })
  })

  return movedRoutes
}
